import * as React from 'react'
import { ErrorMessage } from '../../../shared-components/ErrorMessage'
import { RadioButton } from '../../../shared-components/RadioButton'
import { useScreenTracking } from '../../../shared-hooks/useScreenTracking'
import { track } from '../../../utils/analytics'
import { SignupCard } from '../SignupCard'
import { SSOStepProps } from './SSOFlow'

type AccountSelectionProps = SSOStepProps & {
  sessionId: string
  emailHints: string[]
}

export const AccountSelection = ({
  sessionId,
  emailHints,
  makeSSORequest,
}: AccountSelectionProps): JSX.Element => {
  useScreenTracking(
    'UberAccountSelectionView',
    'View uber account selection screen'
  )

  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setIsSubmitting(true)
    setErrorMessage('')

    track('UberSelectAccount', 'Uber select account')

    const selectedAccount = event.currentTarget.value
    const accountIndex = emailHints.indexOf(selectedAccount)
    if (accountIndex === -1) {
      setErrorMessage('Please select an account.')
      setIsSubmitting(false)
      return
    }

    const body = {
      session_id: sessionId,
      stage: 'sign_in',
      event_type: 'TypeSelectAccount',
      credentials: {
        account_index: accountIndex + 1,
      },
    }

    try {
      await makeSSORequest(
        body,
        'Something unexpected happened, please try again later.'
      )
    } catch (error) {
      setIsSubmitting(false)
      setErrorMessage(error?.message)
    }
  }

  return (
    <SignupCard
      heading='Select your account'
      subheading='Select the email below that is associated with your Uber Driver account'
    >
      <div className='flex flex-col gap-4'>
        {emailHints.map((account) => (
          <RadioButton
            key={account}
            value={account}
            onClick={handleClick}
            disabled={isSubmitting}
          >
            {account}
          </RadioButton>
        ))}
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </div>
    </SignupCard>
  )
}
